import { DEFAULT_TEAM_UNIFORM } from "../../../../../sports/common/players/TeamPlayer";
import FootballState from "../../../../../sports/football/state/football-state";
import {
    getSafetyRecoveringPlayer,
    getSafetyTacklingPlayer,
    isSafety
} from "../../../../../sports/football/utils/context-utils";
import { FragmentSerializer } from "./FragmentSerializer";

export class SafetyFragmentSerializer extends FragmentSerializer {
    applicable(fragment) {
        return fragment.associatedState === FootballState.Safety;
    }

    getRawFragment(play, serializationContext, safety) {
        let rawPlay = "";

        if (
            safety &&
            isSafety(play, safety, serializationContext.gameContext)
        ) {
            const safetyTacklingPlayer = getSafetyTacklingPlayer(play, safety);
            const safetyRecoveringPlayer = getSafetyRecoveringPlayer(
                play,
                safety
            );
            const values = [];
            if (safetyTacklingPlayer) {
                values.push(
                    this.resolveTeam(serializationContext, safetyTacklingPlayer)
                );
                // TODO: We can remove this once CMS makes uniform option for Safety
                values.push(DEFAULT_TEAM_UNIFORM);
            } else if (safetyRecoveringPlayer) {
                values.push(
                    this.resolveOpponent(
                        serializationContext,
                        safetyRecoveringPlayer
                    )
                );
                values.push(DEFAULT_TEAM_UNIFORM);
            } else {
                // Fumble dead in the offense's own end zone (flag football):
                // no player performed the safety, so credit the defending
                // team directly. The CMS parser requires both tokens.
                const { homeTeamHasPossession } = play.getEndContext(
                    serializationContext.gameContext
                );
                values.push(homeTeamHasPossession ? "V" : "H");
                values.push(DEFAULT_TEAM_UNIFORM);
            }

            rawPlay = `SAF:${values.join()}`;
        }

        return rawPlay;
    }
}
